/**
 * @desc 根据ShopKey列表查询站点店铺
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformSiteShopResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/cacheListByShopKeys`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
